// Home.jsx

import React from 'react';
import '../styles/Home/Home.scss';
import SlideShow from '../components-templates/Home/slideshow';

const Home = () => {
  return (
    <div className="home">
      <SlideShow />
    </div>
  );
};

export default Home;
